import { deleteUser } from 'firebase/auth';
import { prepareBillingForAccountDeletion } from '../billingApi';

export function applicationConnectionKeys(applications = {}, connectionIndex = {}) {
  // Application map keys are job IDs. Delete only explicit connection IDs so
  // account cleanup can never mistake a job for another user's chat thread.
  const applicationKeys = Object.values(applications)
    .map((application) => application?.threadId || application?.connectionKey || '');
  const indexedKeys = Object.entries(connectionIndex)
    .map(([connectionKey, value]) => value?.connectionKey || value?.threadId || connectionKey);
  return [...new Set([...applicationKeys, ...indexedKeys].filter(Boolean))];
}

export async function deleteJobSeekerAccount({ user }) {
  if (!user?.uid) {
    throw new Error('Missing authenticated user.');
  }

  // The authenticated backend cancels billing and removes database records.
  // Browser rules deliberately cannot delete protected account-owned data.
  const cleanup = await prepareBillingForAccountDeletion(user);

  // Firebase Auth may require recent sign-in for this final step.
  await deleteUser(user);

  return {
    deletedConnectionCount: cleanup.deletedConnectionCount || 0,
    deletedUserId: user.uid,
  };
}
